import type {CHeliLiveChannel} from './CHeliLiveChannel';
import type {IHeliNetError} from './IHeliNetError';

export class CHeliLiveChannelList implements IHeliNetError {
  m_live_channels: Array<CHeliLiveChannel>;
  m_offset: number;
  m_limit: number | null;
  m_errorCode: string | null = null;
  m_errorData: unknown = null;

  constructor(
    live_channels: Array<CHeliLiveChannel> = [],
    offset: number = 0,
    limit: number | null = null
  ) {
    this.m_live_channels = live_channels;
    this.m_offset = offset;
    this.m_limit = limit;
  }

  getList(): Array<CHeliLiveChannel> {
    return this.m_live_channels.slice(
      this.m_offset,
      this.m_limit !== null ? this.m_offset + this.m_limit : undefined
    );
  }

  setError({code, data}: {code: string | null; data: unknown}) {
    this.m_errorCode = code;
    this.m_errorData = data;
  }
  getErrorCode(): string | null {
    return this.m_errorCode;
  }
  getErrorData(): unknown {
    return this.m_errorData;
  }
  isValid() {
    return this.m_errorCode === null && this.m_errorData === null;
  }
}
